import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { langs } from './languages';
import { getLangCode } from './langBasename';

const supportedLngs = Object.keys(langs);

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'path',
  lookup: () => getLangCode(),
});

i18n
  .use(HttpBackend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    // Path-derived language is authoritative — set it explicitly so it overrides the
    // cookie/navigator (the detector order alone did not reliably beat the lng cookie).
    lng: getLangCode(),
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json`,
    },

    // debug: process.env.NODE_ENV === 'development',
    debug: false,

    defaultNS: 'translations',

    detection: {
      caches: [], // don't let the client write the lng cookie; the server (langPrefix) owns it

      order: ['path', 'cookie', 'navigator'],

      lookupCookie: 'lng',
    },

    fallbackLng: 'en',

    interpolation: {
      escapeValue: false, // not needed, React does this.
    },

    keySeparator: '.',

    ns: 'translations',

    supportedLngs,
  });

export default i18n;
